<template>
<Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="shuttle_frame_one" width="700">
    <div class="shuttle_left_one" style="height:350px">
        <div class="font_style_set_one">座席状态列表</div>
        <ul class="popupul">
            <li v-for="(item,index) in leftData" :key="index+'left'" @mouseenter="entersATwo(item.id)" @mouseleave="leaverATwo(item.id)">
              <div style="width: 20%; text-align: right;float: left;">
                <span>{{item.statusName}}<span v-if="item.statusName != undefined && item.statusName.length<3">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;</span>
              </div>
              <div style="width: 50%;text-align: left;float: left;">
                <RadioGroup v-model="item.level" size="small" type="button">
                  <Radio v-for="option in levelList" :label="option.id" :key="option.id">{{option.value}}</Radio>
                </RadioGroup>
              </div>
              <div style="width: 30%;text-align: right;float: right;height: 28px;">
                <span v-show="ifShowATwo  && item.id === ifShowAIdTwo" @click="moveToRight(item.statusName,item.id,item.level)" class="setposi">归入其它</span>
              </div>
            </li>
        </ul>
    </div>
    <div class="shuttle_right_one" style="height:350px">
        <div class="font_style_set_one">其它</div>
        <ul class="popupul">
            <li v-for="(item,index) in rightData" style="width: 100%;" :key="index+'right'" @mouseenter="entersBTwo(item.id)" @mouseleave="leaverBTwo(item.id)">
                <div style="width: 20%; text-align: right;float: left;">
                  <span>{{item.statusName}}<span v-if="item.statusName != undefined && item.statusName.length<3">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;</span>
                </div>
                <div style="width: 50%;text-align: left;float: left;">
                  <RadioGroup v-model="item.level" size="small" type="button">
                    <Radio v-for="option in levelList" :label="option.id" :key="option.id">{{option.value}}</Radio>
                  </RadioGroup>
                </div>
                <div style="width: 30%;text-align: right;float: right;height: 28px;">
                  <span v-show="ifShowBTwo && item.id === ifShowBIdTwo" @click="moveToLeft(item.statusName,item.id,item.level)" class="setposi">移出其它</span>
                </div>
            </li>
        </ul>
    </div>
    <div style="text-align:right;">
        <Button type="primary" class="submit_btn" @click="save()" style="display:inline-block">确认</Button>
        <Button type="error" class="cancel_btn" @click="cancel()" style="display:inline-block">取消</Button>
    </div>
</Modal>
</template>

<script>
export default {
    name: "BigScreenTwoPop",
    props: {
        idForShow: String,
        statusForShow: Array,
        showBigScreenTwo: Boolean,
    },
    data() {
        return {
            id: '',
            ifShowATwo: false,
            ifShowAIdTwo: '',
            ifShowBTwo: false,
            ifShowBIdTwo: '',
            leftData: [],
            initData: [{
                    id: '0',
                    statusName: '空闲',
                    level: '0'
                }, {
                    id: '2',
                    statusName: '通话中',
                    level: '0'
                }, {
                    id: '6',
                    statusName: '忙碌',
                    level: '0'
                }, {
                    id: '5',
                    statusName: '被占用',
                    level: '0'
                },
                {
                    id: '7',
                    statusName: '离开',
                    level: '0'
                }, {
                    id: '8',
                    statusName: '仅呼出',
                    level: '0'
                }, {
                    id: '4',
                    statusName: '后处理',
                    level: '0'
                }, {
                    id: '3',
                    statusName: '保持',
                    level: '0'
                }, {
                    id: '1',
                    statusName: '振铃',
                    level: '0'
                }, {
                    id: '-1',
                    statusName: '离线',
                    level: '0'
                }
            ],
            rightData: [],
            shuttleRightList: [],
            shuttleLeftList: [],
            model: false,
            spinShow: true,
            journalType: '',
            menuIdL: '',
            title: '',
            modelHeight: {
                'maxHeight': '',
                'marginTop': '20px'
            },
            baseUploadUrl: "",
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            levelList: [{
                id: '0',
                value: '不显示'
            }, {
                id: '1',
                value: '显示'
            }],
            showStatus: ['0', '2', '6', '-1'],
            queryStatus: ['0', '2', '6', '-1'],
        }
    },
    methods: {
        entersATwo(index) {
            this.ifShowATwo = true;
            this.ifShowAIdTwo = index;
        },
        leaverATwo(index) {
            this.ifShowAIdTwo = '';
            this.ifShowATwo = false;
        },
        entersBTwo(index) {
            this.ifShowBTwo = true;
            this.ifShowBIdTwo = index;
        },
        leaverBTwo(index) {
            this.ifShowBTwo = false;
            this.ifShowBIdTwo = '';
        },
        moveToRight(statusName, id, level) {
            let that = this;
            for (let i = 0; i < that.leftData.length; i++) {
                if (that.leftData[i].id === id) {
                    that.leftData.splice(i, 1);
                    let param = {
                        id: id,
                        statusName: statusName,
                        level: '0',
                    }
                    if (id === '0' || id === '2' || id === '6' || id === '-1') { //空闲、通话、忙碌、离线
                        param.level = '1';
                    }
                    that.rightData.push(param);
                }
            }
        },

        moveToLeft(statusName, id, level) {

            let that = this;
            for (let i = 0; i < that.rightData.length; i++) {
                if (that.rightData[i].id === id) {
                    that.rightData.splice(i, 1);
                    let param = {
                        id: id,
                        statusName: statusName,
                        level: '0',
                    }
                    if (id === '0' || id === '2' || id === '6' || id === '-1') { //空闲、通话、忙碌、离线
                        param.level = '1';
                    }
                    that.leftData.push(param);
                }
            }
        },

        cancel: function () {
            this.$emit("closeBigScreenTwo", false);
            return false;
        },
        save: function () {
            let that = this;

            this.$Modal.confirm({
                title: '提示',
                content: "是否保存当前修改",
                onOk: () => {
                    if (that.leftData.length == 0) {
                        that.$Message.info("座席状态列表不能为空");
                        return;
                    }
                    
                    // queryStatus
                    that.queryStatus.splice(0, that.queryStatus.length);
                    that.showStatus.splice(0, that.showStatus.length);
                    for (let n = 0; n < that.leftData.length; n++) {
                        that.queryStatus.push(that.leftData[n].id);
                        if (that.leftData[n].level === '1') {
                            that.showStatus.push(that.leftData[n].id);
                        }
                    }

                    for (let n = 0; n < that.rightData.length; n++) {

                        if (that.rightData[n].level === '1') {
                            that.showStatus.push(that.rightData[n].id);
                        }
                    }

                    let param = {
                        id: that.id,
                        configValue: {
                            'showStatus': that.showStatus.join(","),
                            'queryStatus': that.queryStatus.join(",")
                        },
                        type: 'workPlace',
                        journalType: "大屏展示=>座席职场=>设置",
                        menuId: "8_5-2",
                    };
                    that.$http.post("bigScreen/doSave.json", param).then(function (res) {
                        let result = res.data.flag;
                        if (result != "666") {
                            that.$alert(res.data.msg, '提示', {
                                confirmButtonText: '确定'
                            });
                            return false;
                        }
                        that.$Message.info("座席状态设置成功");
                        that.$emit("closeBigScreenTwo", true);
                    });
                }
            });
        },

        initSearch: function () {
            let that = this;
            let param = {
                type: 'workPlace'
            }
            that.$http.post("bigScreen/toDesign.json", param).then(function (res) {
                let result = res.data.flag;
                if (result != '666') {
                    that.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定'
                    });
                    return false;
                }
                that.id = res.data.obj.configList.id;
                result = JSON.parse(res.data.obj.configList.value);
                that.showStatus = result.showStatus.split(',');
                that.queryStatus = result.queryStatus.split(',');

                // 拼装leftData和rightData
                that.leftData.splice(0, that.leftData.length);
                that.rightData.splice(0, that.rightData.length);

                // for循环判断是否显示
                for (let n = 0; n < that.initData.length; n++) {
                    if (that.showStatus.indexOf(that.initData[n].id) < 0) { //不包含，不显示
                        that.initData[n].level = '0';
                    } else {
                        that.initData[n].level = '1';
                    }

                }

                // for循环判断是左边数据
                for (let n = 0; n < that.initData.length; n++) {

                    if (that.queryStatus.indexOf(that.initData[n].id) < 0) { //不包含，在右侧
                        that.rightData.push(that.initData[n]);
                    } else {
                        that.leftData.push(that.initData[n]);
                    }

                }
            });
        },

    },
    watch: {
        showBigScreenTwo: function () {
            this.model = this.showBigScreenTwo;
            if (this.showBigScreenTwo) {
                this.spinShow = true;
                this.queryStatus = this.statusForShow;
                this.id = this.idForShow;
                this.title = '编辑座席职场';
                this.initSearch();
            }
        }
    }
}
</script>

<style lang="less">
@import "../../assets/css/daping.less";
</style>



// WEBPACK FOOTER //
// src/components/bigScreen/BigScreenTwoPop.vue